<template>
    <div id="paypal_btn">
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex"
export default {
    name: 'paypal-button',
    computed: {
        ...mapState(['billing_info', 'shipping_info'])
    },
    mounted() {

        try {
            paypal.Buttons({
                createOrder: (data, actions) => {
                    this.checkCartItems()
                    this.billing_info.billing_phone_number = this.billing_info?.billing_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    this.shipping_info.shipping_phone_number = this.shipping_info?.shipping_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    this.emptyNotes()
                    return axios.post('/paypal/set-express-checkout', {
                        ...this.$store.getters.expressCheckoutRequest,
                        ...{order_page: window.sabmitOrderPage},
                        ...{failed_order: this.failedOrder},
                        ...{coupon: this.$store.getters.coupon},
                        ...{hash: this.$store.getters.cartHash},
                        ...{shared_cart_hash: this.$store.state.cart.sharedCartHash},
                    }).then(function({data}) {
                        return data.Token;
                    }).catch(errors => {
                        setTimeout(function(){
                                window.scroll({
                                    top: 0-1000,
                                    behavior: 'smooth' // Optional: Use smooth scrolling animation
                                });
                             }, 1000);

                        if (errors.response && errors.response.status === 422 && errors.response.data) {
                            const errs = []
                            for (const item in errors.response.data.errors) {
                                errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                            }
                            this.addNote({items: errs})
                        }

                        let value = this.billing_info.billing_phone_number
                        if (value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.billing_info.billing_phone_number = value

                        value = this.shipping_info.shipping_phone_number
                        if (value && value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.shipping_info.shipping_phone_number = value
                        
                        if (errors.response && errors.response.status === 500 && errors.response.data) {
                            for(let i = 0; i < errors.response.data.messages.length; i++) {
                                this.addNote({item: {message: errors.response.data.messages[i], type: 'error'}})
                            }
                            this.failedOrder = errors.response.data.order
                        }
                        return null
                    })
                },
                onApprove: (data, actions) => {
                    return actions.order.capture().then((orderData) => {
                        axios.post('/paypal/order/capture', {order: orderData}).then(({data}) => {
                            if(data.status === 'success') {
                                this.removeCoupon()
                                this.clearSharedCartHash()
                                this.emptyCart().then(res => {
                                    this.removeCart()
                                })
                            }
                            window.location.href = data.redirect;

                        })
                    
                    });
                },
                onCancel: function (data) {
                    // alert('payment canceled')
                },
                onError: function (e) {
                    // alert('payment error')
                    let messages = [];
                    if(e)
                    {                        
                        let response = JSON.parse(e.message);
                        
                        
                        for(let i = 0; i < response.body.details.length; i++) {
                            messages[i] = {item: {message: response.body.details[i].description, type: 'error'}}
                        }

                        for(let i = 0; i < messages.length; i++) {
                            this.addNote({item: {message: messages[i].item.message, type:messages[i].item.type}})
                        }
                    }                                 
                   
                    window.scroll({
                        top: 0-1000,
                        behavior: 'smooth' // Optional: Use smooth scrolling animation
                    });
                   
                    return null;
                }.bind(this)
            }).render('#paypal_btn');
        }catch(e) {
            window.scroll({
                top: 0-1000,
                behavior: 'smooth' // Optional: Use smooth scrolling animation
            });
        }



    },
    data() {
      return {
          failedOrder: null
      }
    },
    methods: {
        ...mapActions(['addNote', 'emptyNotes', 'emptyCart', 'removeCoupon', 'clearSharedCartHash','removeCart','checkCartItems']),
    }
}
</script>
